import { Drawer } from 'antd'
import { IntercomUtils } from 'main/common/components/intercom/inner/IntercomUtils'
import styled from 'main/config/theme/styledWithTheme'
import React, { useEffect, useState } from 'react'
import { useScreenSize } from 'main/common/responsiveness/use-screen-size/UseScreenSize'
import { LoadingOverlayCP } from 'main/common/components/loading/loading-overlay/LoadingOverlayCP'
import { DrawerFooterICP } from 'main/common/components/drawer/inner/DrawerFooterICP'
import { RequestConfigTP } from 'main/common/request-manager/types/RequestConfigTP'
import { useRequest } from 'main/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'main/common/request-manager/RequestUtils'

type _AntPropsTP = {
    title: string | JSX.Element,
    visible?: boolean,
    footer?: JSX.Element,
    onClose?: () => void,
    loading?: boolean,
    width?: number,
    closable?: boolean,
    maskClosable?: boolean,
    placement?: 'left' | 'right',
    showMask?: boolean,
}

type _ScpPropsTP = {
    rightPadding?: number,
    titleUnderline?: boolean,
    footerSpaced?: boolean,
}

interface IDrawerCPProps extends React.PropsWithChildren<_ScpPropsTP & _AntPropsTP> {
    requestMainEntityConfig?: () => RequestConfigTP
    onLoadMainEntity?: (mainEntity: any) => void
}

/**
 * COMPONENTE: Drawer generico.
 */
export function DrawerCP(props: IDrawerCPProps): JSX.Element {

    const screenSize = useScreenSize()
    const [showDrawer, setShowDrawer] = useState<boolean>()

    const searchRequest = useRequest<any>()
    useEffect(onSearchRequestChange, [searchRequest.isAwaiting])

    useEffect(init, [props.visible])

    /**
     * Inicializa.
     */
    function init(): void {

        setShowDrawer(!!props.visible)

        if (!props.visible)
            return

        IntercomUtils.setIntercomVisibility(false)

        if (!!props.requestMainEntityConfig)
            searchRequest.runRequest(props.requestMainEntityConfig())

    }

    /**
     * Retorno da busca.
     */
    function onSearchRequestChange(): void {

        if (!RequestUtils.isValidRequestReturn(searchRequest, 'Erro ao buscar dados'))
            return

        props.onLoadMainEntity?.(searchRequest.responseData)
    }

    /**
     * Ao fechar.
     */
    function handleClose(): void {
        if (!!props.onClose)
            props.onClose()
        else
            setShowDrawer(false)
        IntercomUtils.setIntercomVisibility(true)
    }

    return (
        <WrapperSCP rightPadding={props.rightPadding}>
            <Drawer
                visible={showDrawer}
                placement={props.placement ?? 'right'}
                closable={props.closable ?? true}
                destroyOnClose={true}
                onClose={handleClose}
                maskClosable={props.maskClosable ?? props.closable ?? true}
                mask={props.showMask}
                zIndex={10}
                width={screenSize.smd ? 'inherit' : (props.width ?? 450)}
                title={props.title}
            >

                <ContentWrapperSCP>

                    <LoadingOverlayCP show={props.loading ?? searchRequest.isAwaiting ?? false}/>

                    { props.children }
                </ContentWrapperSCP>

                {
                    props.footer &&
                    <DrawerFooterICP footerSpaced={props.footerSpaced}>
                        { props.footer }
                    </DrawerFooterICP>
                }
            </Drawer>
        </WrapperSCP>
    )
}

const WrapperSCP = styled.div<_ScpPropsTP>`

    .ant-drawer-title {
         font-size: 20px;
    }

    .ant-drawer-content {
        height: 100vh;
    }
    .ant-drawer-wrapper-body {
        overflow: hidden !important;
        display: flex;
        flex-direction: column;
    }

    .ant-drawer-header {
        position: relative;
        color: rgba(1, 1, 2, 0.65);
        background: ${props => props.theme.white};
        border-bottom: none;
        border-radius: 4px 4px 0 0;
    }
    .ant-drawer-body {
        margin-right: ${props => (props.rightPadding ? props.rightPadding : 0)}px;
        overflow: hidden;
        height: 100%;
        padding: 0 24px;
    }
    .anticon{
        color: ${props => props.theme.black};
    }
`

const ContentWrapperSCP = styled.div`
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
`
